var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_cof.js
// module id = 1492
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 13 14 15 16